// Suggestion types that are not yet a fully resolved address (e.g. just a street name
// or an access address without floor/door) and require another round of searching.
// Mirrors `AdresseSearchUI.selectProcessor()` in the official "Adressevælger" package
// (https://github.com/Klimadatastyrelsen/adressevaelger) for the "adresser" search
// type (the granularity this component always searches at).
//
// The actual search request/response handling is generated RTK Query code - see
// ./src/api/openapi/adressevaelger.openapi.json and
// ./src/api/generated/configs/rtk-openapi.adressevaelger.config.cjs.
export const ADRESSEVAELGER_REFINEMENT_TYPES = new Set([
  'vejnavn',
  'navngivenvejpostnummer',
  'husnummer',
]);
